const showAvailableButtons = editor => {
  editor.Panels.getPanels().forEach(p => {
    const pid = p.get('id');
    const btns = p.get('buttons')?.models || [];
    btns.forEach(b => {
      console.log('[panel-btn]', {
        panel: pid,
        id: b.id || b.get?.('id'),
        command: b.get?.('command') || null,
      });
    });
  });
};

const showBlocks = editor => {
  editor.BlockManager.getAll().forEach(b => {
    console.log('block:', b.id);
  });
};

const removeBlock = (editor, blockId) => {
  editor.BlockManager.remove(blockId);
};

const chnageHeroBlockContent = editor => {
  const heroBlock = editor.BlockManager.get('mj-hero'); // adjust if your id is different
  const oldContent = heroBlock.get('content');

  console.log('oldContent: = ', oldContent);
  // get current domain
  const newContent = `
    <mj-hero mode="fixed-height" height="469px" background-width="600px" background-height="469px" background-url="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764230949398.png" background-color="#2a3448" padding="100px 0px">
        <mj-text padding="20px" color="#ffffff" font-family="Helvetica" align="center" font-size="45px" line-height="45px" font-weight="900">
          Hello WineLovers!
        </mj-text>
        <mj-button href="https://sharevino.co" align="center">
            View Wines
        </mj-button>
    </mj-hero>
    `;

  heroBlock.set('content', newContent);
};

const changeWrapperBlockContent = editor => {
  const wrapperBlock = editor.BlockManager.get('mj-wrapper');
  const oldContent = wrapperBlock.get('content');
  console.log('oldContent: = ', oldContent);
  const newContent = `
    <mj-wrapper border="1px solid #000000" padding="50px 30px">
      <mj-section border-top="1px solid #aaaaaa" border-left="1px solid #aaaaaa" border-right="1px solid #aaaaaa" padding="20px">
        <mj-column>
          <mj-image padding="0" src="https://sharevinomedia-st.s3-us-west-2.amazonaws.com/email-assets/1764230949398.png" />
        </mj-column>
      </mj-section>
      <mj-section border-left="1px solid #aaaaaa" border-right="1px solid #aaaaaa" padding="20px" border-bottom="1px solid #aaaaaa">
        <mj-column border="1px solid #dddddd">
          <mj-text padding="20px"> First line of text </mj-text>
          <mj-divider border-width="1px" border-style="dashed" border-color="lightgrey" padding="0 20px" />
          <mj-text padding="20px"> Second line of text </mj-text>
        </mj-column>
      </mj-section>
    </mj-wrapper>
  `;
  wrapperBlock.set('content', newContent);
};

export { showAvailableButtons, showBlocks, removeBlock, chnageHeroBlockContent, changeWrapperBlockContent };
